//require('babel-polyfill')
let $ = require('jquery');

import GoogleMap from 'vo2018-global/src/components/widgets/googlemap/googlemap';
import HeroVideo from 'vo2018-global/src/components/homepage/heroVideo';
import cookieBar from 'vo2018-global/src/components/cookieBar/cookieBar';
import dropNavigation from 'vo2018-global/src/components/dropNavigation/dropNavigation';

$(document).ready(() => {
	GoogleMap.init();
	HeroVideo.init();
	cookieBar.init();
	dropNavigation.init()

	$(window).scroll(() => {
	});
});
